/* istanbul ignore file */
import useClient from './useClient';

export default useClient;
